<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4" v-if="cartype">
      <div class="card-header row m-0">
        <div class="col">
          <h4>{{cartype.name}} машины маркууд</h4>
        </div>
        <div class="col-auto">
   
            <div class="btn btn-success btn-sm" data-toggle="modal"
          data-target="#proModal">Марк нэмэх</div>

        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="categories!=null && categories.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Нэр</th>
                <th>Аралын тоо</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(category, index) in categories" v-bind:key="category.id">
                <td>{{index+1}}</td>
             
                <td>{{category.name}}</td>
                <td>{{category.numberOfChildren}}</td>

                <td>
                  <div class="row">
                    <button class="btn btn-success btn-sm mx-1" @click="goDetail(category)">арал +</button>
                    <button class="btn btn-warning btn-sm mx-1" @click="edit(category)">засах</button>
                    <button class="btn btn-danger btn-sm ml-2" @click="deleteMark(category)">устгах</button>
                    <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
        </div>
      </div>
    </div>



    <!-- Modal -->
    <div
      class="modal fade"
      id="proModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">марк нэмэx</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Нэр</label>
                <input
                  v-model.trim="pro.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="Нэрээ оруулна уу"
                />
              </div>
              
              <div class="form-group">
                <label>Товчилсон нэр</label>
                <input
                  v-model.trim="pro.shortName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Товчилсон нэр"
                />
              </div>
              <div class="form-group">
                <label>Англи нэр</label>
                <input
                  v-model.trim="pro.engName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Англи нэр"
                />
              </div>
              <div class="form-group">
                <label>Дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="pro.description"
                  class="form-control"
                  placeholder="Тайлбар мэдээлэлээ оруулна уу"
                />
              </div>
              <div class="form-group">
                <label>Хайлтын түлхүүр үгс/таслалаар хуваан бичих/</label>
                <input
                  v-model.trim="pro.tag"
                  class="form-control"
                  placeholder="Түлхүүр үгс"
                />
              </div>
              
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveCategory"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
const axios = require('axios').default;
export default {
  name: "CarMarks",
  data() {
    return {
      msg: "Cars",
      categories: [],
      pro:{
        name:null,
        shortName:null,
        engName:null,
        description:null,
        tag:null

      }, 
      cartype:null

    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  props:{
    cartypeId:{
      required:true
    }
  },
  created() {
    if(this.cartypeId!=null && this.cartypeId!=undefined){
      this._getObjects();
    }
    this.set();
    console.log("hi")

  },
  methods: {
    async set(){
      console.log("SET");


      console.log("DONE");
    },

    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    _getObjects() {
      var _this = this;
      var vm = this;
      fb.db.collection("cartypes").doc(this.cartypeId).get().then(doc=>{
        if(doc.exists){
          let data=doc.data();
          data.id=doc.id;
          this.cartype=data;
          doc.ref
            .collection("marks")
            .onSnapshot( querySnapshot1 => {
              vm.categories = [];
              querySnapshot1.forEach(data => {
                let car = data.data();
                car.id = data.id;
                vm.categories.push(car);


              });
            });
        }
      })
      


    },
    goDetail(obj) {
      this.$router.push({
        name: "Aral",
        params: { cartypeId: this.cartypeId, carMarkId: obj.id }
      });
    },
    edit(category) {
      this.pro = Object.assign({}, category);
      $("#proModal").modal("toggle");
    },
    deleteMark(mark){
      var result = confirm("Та "+mark.name+" устгах уу?");
      if (result) {
          fb.db.collection("cartypes").doc(this.cartypeId).collection("marks").doc(mark.id).delete();
      }
    },
    saveCategory() {
      if (
        this.pro != null &&
        this.pro != null &&
        this.pro.name != ""
      ) {
        if (this.pro.id != null && this.pro.id != "") {
          fb.db
            .collection("cartypes").doc(this.cartypeId).collection("marks")
            .doc(this.pro.id)
            .update({
              name: this.pro.name,
              shortName: this.pro.shortName,
              engName: this.pro.engName,
              description: this.pro.description,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              tag: this.pro.tag!=undefined?this.pro.tag:null
            });
        } 
        else {
          this.pro.createdAt = new Date();
          this.pro.userId = this.$store.getters.currentUser.uid;
          this.pro.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          
          fb.db
            .collection("cartypes").doc(this.cartypeId).collection("marks")
            .doc()
            .set(this.pro);
        }
        this.pro = {
          name: null,
          shortName: null,
          description: null,
          engName:null,
          tag:null
        };
      } else {
        alert("Марк нэрээ оруулна уу");
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  },

  
};
</script>